export class TrackingNumber {

  shipping_number_id: number
  batch_id: number
  company: string
  shipping_number: string
  domestic_tracking_number: string
  ship_date: string
  receive_date: string
  arrived: boolean

  constructor(data: any = {}) {
    this.shipping_number_id = data.shipping_number_id
    this.batch_id = data.batch_id
    this.company = data.company
    this.shipping_number = data.shipping_number
    this.domestic_tracking_number = data.domestic_tracking_number
    this.ship_date = data.ship_date
    this.receive_date = data.receive_date
    this.arrived = data.arrived
  }

  private statusClass(field: string = '_status'): string {
    switch (field) {
      case '_status': return this.arrived ? 'btn-success' : 'btn-danger'
      default: return null
    }
  }

  public toggleArrival() {
    this.arrived = !this.arrived
    this.receive_date = this.arrived ? new Date().toISOString().slice(0, 10) : null
  }

  get _status(): string {
    return this.arrived ? '已到' : '未到'
  }

  get _statusClass(): string {
    return this.arrived ? 'btn-success' : 'btn-danger'
  }

  get tracking_link(): string {
    return this.company.indexOf('星辰') > -1 ? `http://www.xingchenex.com/TrackSearch.aspx?TXT_TRACKNO=${this.shipping_number}` : null
  }

}



// WEBPACK FOOTER //
// ./src/app/models/batch/tracking-number.ts